export const DEFAULT_ADMIN_USERS_EXPORT_PATH = '/admin/user-profiles/export.csv';

function normalizeApiBaseUrl(baseUrl: string): string {
  const trimmed = baseUrl.replace(/\/+$/, '');
  const withoutGraphql = trimmed.endsWith('/graphql')
    ? trimmed.slice(0, -'/graphql'.length)
    : trimmed;
  return withoutGraphql.replace(/\/+$/, '');
}

export function resolveAdminUsersExportPath(): string {
  const override = (import.meta.env.VITE_ADMIN_USERS_EXPORT_PATH as string | undefined)?.trim();
  if (override) {
    return override.startsWith('/') ? override : `/${override}`;
  }
  return DEFAULT_ADMIN_USERS_EXPORT_PATH;
}

export function getAdminUsersExportCsvUrl(baseUrl: string, resourcePath: string): string {
  const base = normalizeApiBaseUrl(baseUrl);
  const path = resourcePath.startsWith('/') ? resourcePath : `/${resourcePath}`;
  return `${base}${path}`;
}
